<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.contractCode')">
              <j-input :placeholder="$t('label.pleaseEnterTheContractCode')" v-model="queryParam.code"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="合同描述">
              <j-input placeholder="请输入合同描述" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>
         <!-- <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="是否有效">
                <j-dict-select-tag placeholder="请选择是否有效" v-model="queryParam.validFlag" dictCode="sfyx"/>
              </a-form-item>
            </a-col>
          </template>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
             <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('合同')">{{$t('button.export')}}</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
<!--      </a-upload>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>-->
<!--      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <span  v-if="record.status=='N'">
          <a v-if="record.approvalStatus!='30'" @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider v-if="record.approvalStatus!='30' "type="vertical" />
            </span>
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleCopy(record)">复制</a>
              </a-menu-item>
               <a-menu-item v-if="record.status=='N'">
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.reviewApproved')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.status=='N'">
                  <a-popconfirm :title="$t('tip.rejected')" @confirm="() => handleFailure(record.id)">
                 <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
<!--              <a-menu-item>-->
<!--                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">-->
<!--                  <a>{{$t('button.delete')}}</a>-->
<!--                </a-popconfirm>-->
<!--              </a-menu-item>-->
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-contract-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdContractModal from './modules/EfsMdContractModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import JInput from '@/components/jeecg/JInput'
  import { putAction } from '@api/manage'

  export default {
    name: "EfsMdContractList",
    mixins:[JeecgListMixin],
    components: {
      EfsMdContractModal,
      JInput
    },
    data () {
      return {
        description: '合同管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'tableHeader.contractCode',
            scopedSlots: { title: 'tableHeader.contractCode'},
            align:"center",
            dataIndex: 'code'
          },
          {
            title:'合同描述',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'合同大类',
            align:"center",
            dataIndex: 'conCategory_dictText'
          },
          {
            title:'合同小类',
            align:"center",
            dataIndex: 'conType_dictText'
          },
          {
            slotName: 'tableHeader.batchCode',
            scopedSlots: { title: 'tableHeader.batchCode'},
            align:"center",
            dataIndex: 'breedBatchCode'
          },
          {
            slotName: 'tableHeader.partyA',
            scopedSlots: { title: 'tableHeader.partyA'},
            align:"center",
            dataIndex: 'paCompanyCode_dictText'
          },
          {
            title:'甲方部门',
            align:"center",
            dataIndex: 'paDeptCode_dictText'
          },
          {
            slotName: 'tableHeader.partyB',
            scopedSlots: { title: 'tableHeader.partyB'},
            align:"center",
            dataIndex: 'pbFarmerCode_dictText'
          },
          {
            title:'合同开始日期',
            align:"center",
            dataIndex: 'conStartDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'合同结束日期',
            align:"center",
            dataIndex: 'conEndDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            slotName: 'tableHeader.cooperationModel',
            scopedSlots: { title: 'tableHeader.cooperationModel'},
            align:"center",
            dataIndex: 'cooperMode_dictText'
          },
          {
            title:'再次合作模式',
            align:"center",
            dataIndex: 'reCooperMode_dictText'
          },
          {
            title:'紧急程度',
            align:"center",
            dataIndex: 'urgentDegree_dictText'
          },
          {
            title:'合同文本',
            align:"center",
            dataIndex: 'contractFileUrl'
          },
          // {
          //   title:'甲方签订日期',
          //   align:"center",
          //   dataIndex: 'partyASignDate',
          //   customRender:function (text) {
          //     return !text?"":(text.length>10?text.substr(0,10):text)
          //   }
          // },
          {
            title:'签订日期',
            align:"center",
            dataIndex: 'partyBSignDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'重量合计',
            align:"center",
            dataIndex: 'totalWeight'
          },
          {
             slotName: 'tableHeader.unitPrice',
            scopedSlots: { title: 'tableHeader.unitPrice'},
            align:"center",
            dataIndex: 'unitPrice'
          },
          {
            title:'价税合计',
            align:"center",
            dataIndex: 'totalWithTax'
          },
          {
            title:'价税合计(大写)',
            align:"center",
            dataIndex: 'totalWithTaxCn'
          },
          {
            title:'不含税合计',
            align:"center",
            dataIndex: 'totalExclTax'
          },
          {
            title:'不含税合计(大写)',
            align:"center",
            dataIndex: 'totalExclTaxCn'
          },
          {
            title:'税额合计',
            align:"center",
            dataIndex: 'totalTax'
          },
          {
            title:'税额合计(大写）',
            align:"center",
            dataIndex: 'totalTaxCn'
          },
          {
            title:'付款说明',
            align:"center",
            dataIndex: 'payTerm'
          },
          {
            title:'特殊扣款约定',
            align:"center",
            dataIndex: 'withholdTerm'
          },
          {
            title:'甲方签署信息',
            align:"center",
            dataIndex: 'paSignInfo'
          },
          {
            title:'乙方签署信息',
            align:"center",
            dataIndex: 'pbSignInfo'
          },
          {
            title:'会签要点',
            align:"center",
            dataIndex: 'signKeyPoint'
          },
          {
            slotName: 'tableHeader.remarks',
            scopedSlots: { title: 'tableHeader.remarks'},
            align:"center",
            dataIndex: 'remarks'
          },
          {
            slotName: 'tableHeader.reviewStatus',
            scopedSlots: { title: 'tableHeader.reviewStatus'},
            align:"center",
            dataIndex: 'approvalStatus_dictText'
          },
          {
            slotName: 'tableHeader.applicant',
            align:"center",
            dataIndex: 'applicant_dictText',
            scopedSlots: { title: 'tableHeader.applicant'}
          },
          {
            slotName: 'tableHeader.lastApprover',
            scopedSlots: { title: 'tableHeader.lastApprover'},
            align:"center",
            dataIndex: 'lastApprover_dictText'
          },
          {
            slotName: 'tableHeader.lastApprovalTime',
            scopedSlots: { title: 'tableHeader.lastApprovalTime'},
            align:"center",
            dataIndex: 'lastApproveTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          /*{
                slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
                align:"center",
                dataIndex: 'validFlag_dictText'
            },*/
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
          }
        ],
        url: {
          list: "/contractManage/efsMdContract/list",
          delete: "/contractManage/efsMdContract/delete",
          deleteBatch: "/contractManage/efsMdContract/deleteBatch",
          exportXlsUrl: "/contractManage/efsMdContract/exportXls",
          importExcelUrl: "contractManage/efsMdContract/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      handleFailure(id){
        putAction('/contractManage/efsMdContract/updateApprovalStatus', {"id": id, "approvalStatus": "40"}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.error(res.message);
          }
        })
      },
      handlePass(id){
        putAction('/contractManage/efsMdContract/updateApprovalStatus', {"id": id, "approvalStatus": "30"}).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.loadData();
          } else {
            this.$message.error(res.message);
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>